import { render, staticRenderFns } from "./SelectSession.vue?vue&type=template&id=27bbd151"
import script from "./SelectSession.vue?vue&type=script&lang=js"
export * from "./SelectSession.vue?vue&type=script&lang=js"
import style0 from "./SelectSession.vue?vue&type=style&index=0&id=27bbd151&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports